import { render, staticRenderFns } from "./LcNumberRange.vue?vue&type=template&id=15bc83e5&scoped=true"
import script from "./LcNumberRange.vue?vue&type=script&lang=js"
export * from "./LcNumberRange.vue?vue&type=script&lang=js"
import style0 from "./LcNumberRange.vue?vue&type=style&index=0&id=15bc83e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc83e5",
  null
  
)

export default component.exports